import styled from 'styled-components'

export const WordCloudContainer = styled.div`
  width: 100%;
  min-height: 400px;
  background: #fff;
  border-radius: 8px;
  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); */
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .word-cloud-content {
    width: 100%;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    width: 100% !important;
    height: auto !important;
    display: block;
  }

  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    h3 {
      color: #666;
      font-size: 18px;
      font-weight: 500;
    }
  }
` 